var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.9999V16.8999C9 18.3999 7.4 19.3999 6 18.5999L3.5 17.1999C3.2 17.0999 3 16.7999 3 16.3999V7.5999C3 7.1999 3.2 6.8999 3.5 6.6999L11.5 2.2999C11.8 2.0999 12.2 2.0999 12.5 2.2999L20.5 6.6999C20.8 6.8999 21 7.1999 21 7.5999V16.3999C21 16.7999 20.8 17.0999 20.5 17.2999L12.5 21.6999C12.2 21.8999 11.8 21.8999 11.5 21.6999L10 20.9999",
    stroke: "#9096AD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 10.8C16.9998 9.8 16.1998 9 15.2998 9H13.4998C12.4998 9 11.7998 9.8 11.7998 10.7C11.7998 11.7 12.5998 12.4 13.4998 12.4H15.2998C16.2998 12.4 16.9998 13.2 16.9998 14.1C16.9998 15.1 16.1998 15.8 15.2998 15.8H13.4998C12.4998 15.8 11.7998 15 11.7998 14.1",
    stroke: "#9096AD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.b6c16d3d0681cc092f4ada1c6144968c.svg";
export { ForwardRef as ReactComponent };